import React from 'react';
import Button from '../../Atoms/Button';
import ImgTag from '../../Atoms/ImgTag';

const imageForButton = (props) => {
    return (
        <ImgTag 
            src = {props.imgSrc}
        />
    )
}

const FloatButton = (props) => {
    const classVar = 'float_button_wrapper ' + props.className ? props.className : '';
    return (
        <Button 
            value = {imageForButton(props)}
            className = {classVar}
            buttonOnClick = {props.buttonOnClick ? ((e) => props.buttonOnClick(e)) : ''}
            {...props}
        />
    )
}

export default FloatButton;